import { useCallback, useRef } from 'react';
import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { Typography, Button } from '@mui/material';

import { Input } from '../../../../components/Input';
import { TurnstileWidget } from '../../../../components/TurnstileWidget';

import { Div } from './styles';

import { AuthSectionSteps } from '../../types/AuthSectionSteps';

import useAuthStore from '../../../../store/auth';

import { forgotPasswordRequest } from '../../../../services';

interface EsqueciSenhaProps {
  setStepLogin: (step: AuthSectionSteps) => void;
  setIsLoading: (status: boolean) => void;
}

const hasCaptcha = process.env.REACT_APP_TURNSTILE_ENABLED || 'false';

export const StepEsqueciSenha = ({
  setStepLogin,
  setIsLoading,
}: EsqueciSenhaProps) => {
  const { user, setUser } = useAuthStore(state => state);

  const turnstileRef = useRef<HTMLDivElement | null>(null);

  const formValidation = useCallback(() => {
    return Yup.object().shape({
      email: Yup.string()
        .email('Digite um e-mail válido')
        .required('O campo E-mail é obrigatório.'),
    });
  }, []);

  const { control, handleSubmit, watch } = useForm({
    resolver: yupResolver(formValidation()),
  });

  const tokenValue = watch('token');
  const btnIsDisabledByCaptcha =
    hasCaptcha === 'true' && tokenValue === undefined;

  const handleForgotPassword = useCallback(
    async (formData: any) => {
      try {
        setIsLoading(true);

        const response = await forgotPasswordRequest({
          email: formData?.email,
          token: formData?.token,
        });

        setUser({
          ...user!,
          email: formData?.email,
        });

        if (response?.status === 200) {
          setStepLogin(AuthSectionSteps.RECOVER_PASSWORD_SUCCESS);
        }
      } catch (error) {
        console.log('Error [handleForgotPassword]:', error);
      } finally {
        setIsLoading(false);
      }
    },
    [setIsLoading, setStepLogin, user, setUser],
  );

  return (
    <Div
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      gap="10px"
      width="100%"
    >
      <Typography className="title" sx={{ marginBottom: '15px' }}>
        Recuperar senha
      </Typography>
      <form
        onSubmit={handleSubmit(handleForgotPassword)}
        className="recover-form"
      >
        <Input
          control={control}
          name="email"
          label="Digite seu e-mail cadastrado"
          required
          fullWidth
          sx={{ marginBottom: '0' }}
        />

        <TurnstileWidget
          name="token"
          control={control}
          turnstileRef={turnstileRef}
        />

        <Button
          variant="contained"
          fullWidth
          type="submit"
          sx={{ height: '54px' }}
          disabled={btnIsDisabledByCaptcha}
        >
          Enviar recuperação
        </Button>
      </form>
      <Button
        variant="text"
        onClick={() => setStepLogin(AuthSectionSteps.LOGIN)}
        className="back-to-login"
      >
        Voltar ao login
      </Button>
    </Div>
  );
};
